import { saveWebPushNotificationsOptionsQuick } from './actions/saveWebPushNotificationsOptions';
import NotificationOptionsFull from './components/NotificationOptionsFull';
import { getLocalWebPushUserSetting } from './utils/getLocalWebPushUserSetting';
import { getWebPushNotificationsOption } from './utils/getWebPushNotificationsOption';
import { isFeatureEnabled } from 'owa-feature-flags';
import { Option, QuickSettingOrder } from 'owa-options-core';
import { isWebPushNotificationSupported } from 'owa-webpush-notifications';
import { OwaWorkload } from 'owa-workloads';
import { getOwaWorkload } from 'owa-workloads';
import * as React from 'react';

let NotificationsOptions: Option = {
    key: 'browserNotifications',
    titleStringKey: 'webpushFullSettingsHeader',
    searchTermsStringKey: 'webpushFullSettingsHeader',
    isHidden: () =>
        !(getOwaWorkload() == OwaWorkload.Mail && isWebPushNotificationSupported(window)),
    fullOptionFormSettings: {
        render: () => <NotificationOptionsFull />,
        hideSaveDiscard: () => true,
        isDirty: () => false,
        onSave: Promise.resolve,
        onDiscard: () => {},
    },
    quickOptionSettings: {
        rendering: {
            isToggleOn: () =>
                getWebPushNotificationsOption().enabled && getLocalWebPushUserSetting().enabled,
            onToggle: saveWebPushNotificationsOptionsQuick,
        },
        getOrder: () => {
            return isFeatureEnabled('tri-density-controls')
                ? QuickSettingOrder.DesktopNotificationsDensity
                : QuickSettingOrder.DesktopNotifications;
        },
        workloads: OwaWorkload.Mail,
    },
};

export default NotificationsOptions;
